import React, { useState, useEffect, useRef } from 'react'

import {
    Box,
    IconButton,
} from "@mui/material";
import { copyRight, copyDown } from "./icons";

function PricingCopyMenu({ disableDownCopy, disableRightCopy, onCopyRight, onCopyDown }) {

    const handleCopyRight = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Copy Right Clicked")
        if (onCopyRight) onCopyRight();
    }

    const handleCopyDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Copy Down Clicked")
        if (onCopyDown) onCopyDown();
    }

    if(disableDownCopy && disableRightCopy ) {
        return;
    }

    return (
        <Box className={`pricing-copy-menu ${disableRightCopy ? 'position-left' : 'position-right'}`} >
            <Box
                className="pricing-icon-btns-container"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '100%',
                    transform: 'translateY(-50%)',
                    zIndex: 10,
                }}
            >
                { disableRightCopy ?
                    <svg className='arrow-indecator position-left' xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#fff" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
                    :
                    <svg className='arrow-indecator position-right' xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#fff" viewBox="0 0 256 256"><path d="M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z"></path></svg>
                }
                <div className="icon-btns-group">
                    {!disableRightCopy &&
                        <IconButton
                            className="copy-btn"
                            size="small"
                            onClick={(e) => handleCopyRight(e)}
                            tabIndex={-1}
                        >
                            {copyRight}
                        </IconButton>
                    }
                    {!disableDownCopy &&
                        <IconButton
                            className="copy-btn"
                            size="small"
                            onClick={(e) => handleCopyDown(e)}
                            tabIndex={-1}
                        >
                            {copyDown}
                        </IconButton>
                    }
                </div>
            </Box>
        </Box>
    );

}

export default PricingCopyMenu